module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Quote1-644bb630c8059da8a0cb7f2d24230bd1.svg";